"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferDataField = void 0;
var basePlugin_1 = __importDefault(require("./basePlugin"));
var log_1 = require("../utils/log");
var validators_1 = require("../utils/validators");
var transferDataField = function (data) {
    if (!data) {
        return {};
    }
    var result = {};
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = data[key];
        if ((0, validators_1.isValidTag)(key, value)) {
            result[key] = !value ? '' : typeof value !== 'string' ? value.toString() : value;
        }
    }
    return result;
};
exports.transferDataField = transferDataField;
var isCustomPerfData = function (data) { return data.duration !== undefined; };
var CustomPlugin = /** @class */ (function (_super) {
    __extends(CustomPlugin, _super);
    function CustomPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'customized';
        return _this;
    }
    CustomPlugin.prototype.sendData = function (data) {
        var _a, _b;
        if (!data.point_id) {
            log_1.Logger.warn('[MDAP] Custom Report - point Id is required.');
            return;
        }
        if (isCustomPerfData(data)) {
            (_a = this.triggerHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
                type: 'customized',
                customized_point_id: data.point_id,
                duration: Math.round(data.duration),
                customized_data: (0, exports.transferDataField)(data.data)
            });
        }
        else {
            var dataField = data.data, restProps = __rest(data, ["data"]);
            (_b = this.triggerHandler) === null || _b === void 0 ? void 0 : _b.call(this, __assign(__assign({}, restProps), { type: 'custom_accum', timestamp: this.serverNow(), data: (0, exports.transferDataField)(dataField) }));
        }
    };
    return CustomPlugin;
}(basePlugin_1.default));
exports.default = CustomPlugin;
